module.exports = __webpack_public_path__ + "img/leaveYourLike.48dcae37.svg";